import { Directive, HostBinding, inject, Input } from '@angular/core';

import { Cb2PreviewStateService } from '@core/services/cb2-preview/cb2-preview-state.service';

/**
 * Marks a rendered block as a CB2 studio pick target (overlay + `data-cb2-bloc-key`).
 *
 * Click interception and side-effect blocking live in
 * {@link Cb2PreviewPickGuardService} (document capture phase). This directive
 * only exposes the DOM markers the guard uses to resolve the selected block.
 */
@Directive({
  selector: '[appCb2PickBloc]',
  standalone: true,
})
export class Cb2PickBlocDirective {
  /** Resolved block id (set by BlockFactoryComponent once the block is loaded). */
  @Input('appCb2PickBloc') blockId: string | null = null;

  private readonly previewState = inject(Cb2PreviewStateService);

  @HostBinding('class.cb2-pick-bloc--active')
  get isPickActive(): boolean {
    return this.previewState.isActive() && this.previewState.pickEnabled();
  }

  /**
   * Exposes the block id as a DOM attribute in preview mode so the pick guard /
   * bridge can locate a specific block instance. Each draft block key is unique,
   * so duplicate block types remain independently targetable.
   */
  @HostBinding('attr.data-cb2-bloc-key')
  get blocKeyAttr(): string | null {
    if (!this.previewState.isActive() || !this.blockId) return null;
    return this.blockId;
  }
}
